/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { InteractiveTooltip } from "components/interactiveTooltip/InteractiveTooltip";
import { getActiveVerb } from "selectors/quickToolsSelectors";
import { getLatestHitTestResponse } from "selectors/documentSelectors";
import { getPagesViewBoundingRect } from "selectors/documentViewSelectors";

const mapStoreToProps = stores => ({
  activeVerb: getActiveVerb(stores),
  getLatestHitTestResponse: () => getLatestHitTestResponse(stores),
  getPagesViewBoundingRect: () => getPagesViewBoundingRect(stores)
});

const InteractiveTooltipContainer = inject(mapStoreToProps)(InteractiveTooltip);
export { InteractiveTooltipContainer };
